import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAssignedPermissions } from "../../contents/redux/actions/rolePermissionsActions";
import styles from "../utilities/cssmodules/ViewRole.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";

const ViewRoleContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = location.state?.role;

  const [groupedPermissions, setGroupedPermissions] = useState({});

  // Get assigned permissions from Redux state safely
  const {
    data: assignedPermissions,
    loading: fetchLoading,
    error: fetchError,
  } = useSelector((state) => state.rolePermissions.assignedPermissions || {});

  // Go back to previous component
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!role) {
      navigate("/rolemanagement");
    }
  }, [role, navigate]);

  useEffect(() => {
    if (role?.id) {
      dispatch(fetchAssignedPermissions(role.id));
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (assignedPermissions?.length) {
      const grouped = assignedPermissions.reduce((acc, permission) => {
        const category = permission.permissionCategoryId;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(permission.permissionId);
        return acc;
      }, {});
      setGroupedPermissions(grouped);
    }
  }, [assignedPermissions]);

  return (
    <div className={styles.componentWrapper}>
      <div className={styles.componentTitle}>
        <div className={styles.flexRowContainer}>
          <div className={styles.flexRowCustom1}>
            <span className={styles.titleBackButton} onClick={goBack}>
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View Role</span>
          </div>
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.topInfoText}>
          View details and permissions for <b>{role?.name}</b> role
        </div>

        <div className={styles.componentContentViewWrapper}>
          <div className={styles.componentContentViewSection}>
            <div className={styles.componentContentViewSectionHeader}>
              Details
            </div>
            <div className={styles.componentContentViewSectionGrid}>
              <div className={styles.componentContentViewSectionGridItem}>
                <div className={styles.componentContentViewSectionGridTitle}>
                  Name
                </div>
                <div className={styles.componentContentViewSectionGridData}>
                  {role?.name}
                </div>
              </div>

              <div className={styles.componentContentViewSectionGridItem}>
                <div className={styles.componentContentViewSectionGridTitle}>
                  Description
                </div>
                <div className={styles.componentContentViewSectionGridData}>
                  {role?.description}
                </div>
              </div>

              <div className={styles.componentContentViewSectionGridItem}>
                <div className={styles.componentContentViewSectionGridTitle}>
                  Date created
                </div>
                <div className={styles.componentContentViewSectionGridData}>
                  {role.createdOn
                    ? new Date(role.createdOn).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                    : "N/A"}
                </div>
              </div>

              <div className={styles.componentContentViewSectionGridItem}>
                <div className={styles.componentContentViewSectionGridTitle}>
                  Status
                </div>
                <div className={styles.componentContentViewSectionGridData}>
                  {role.enabled ? "Active" : "Disabled"}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.componentContentViewSection}>
            <div className={styles.componentContentViewSectionHeader}>
              Permissions ({role?.permission})
            </div>

            {fetchLoading ? (
              <div className={styles.loading}>Loading...</div>
            ) : fetchError ? (
              <div className={styles.error}>{fetchError}</div>
            ) : Object.keys(groupedPermissions).length > 0 ? (
              <div className={styles.componentContentViewPermissionsWrapper}>
                {Object.entries(groupedPermissions).map(
                  ([category, permissions]) => (
                    <div
                      key={category}
                      className={styles.componentContentViewPermission}
                    >
                      <div
                        className={
                          styles.componentContentViewPermissionCategory
                        }
                      >
                        {category}
                      </div>
                      <div
                        className={styles.componentContentViewPermissionData}
                      >
                        {permissions.join(", ")}
                      </div>
                    </div>
                  ),
                )}
              </div>
            ) : (
              <div className={styles.componentContentViewPermissionEmpty}>
                No permissions assigned
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRoleContent;
